export default {
    name: 'task_0_3',
	description: 'Заставка',
	title: 'Количество задач',
	minigameType: 'Intro',
	generateParams() {
		return {
            question: "Выберите, сколько задач будет предложено вам в первом раунде",
			options: [
                'Одна', 'Две', 'Пять', 'Десять', 'Двадцать'
			],
			correct: [1, 2]
        };
	},
	isCompleted: () => true,
	messages() {
		return {
			onFinish: () => "Начинаем первый раунд!",
		};
	},
	
}